import React from "react";

const ClientCareSection = ({ section }) => {
  return (
    <div className="flex-column gap-2 break-avoid">
      <div
        className={`applicationTypeHeading${
          section.isHeadingBold ? " text-bold" : ""
        }`}
      >
        {section.key}
      </div>
      <div className="flex-column gap-10">
        {section.value.map((paragraph) => (
          <div className="text-big" key={paragraph}>
            {paragraph}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientCareSection;
